// Best-effort browser outcome counters -> backend POST /api/ecommerce/telemetry -> App Insights.
//
// Mirrors the server-side outcome counters for the few outcomes only observable in the browser
// (was a size chosen before add-to-cart? did the shopper reach/submit checkout? did a magic-link
// actually sign them in?). Fire-and-forget; never throws; never blocks the UI. The server accepts
// ONLY ui.* event names, so nothing here can mint a server-side pay.*/auth.* counter.

import logger from './logger'

// keepalive lets the request survive a navigation (e.g. the checkout submit that redirects).
export function trackUi(event, props) {
  try {
    if (!event || typeof event !== 'string' || event.indexOf('ui.') !== 0) return
    const base = window.VUE_CONFIG_API_ECOMMERCE
    if (!base) return
    const url = (base.charAt(base.length - 1) === '/' ? base : base + '/') + 'telemetry'
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event: event, props: props || {} }),
      keepalive: true,
      mode: 'cors',
      credentials: 'omit'
    }).catch(function () { /* swallow — telemetry must never affect the UI */ })
  } catch (e) {
    logger.debug && logger.debug('[uiTelemetry] skipped:', e && e.message)
  }
}
